import React from 'react';

import './index.scss';

export default function ContentPreview({contentUrl, children}) {
    const content = /\.mp4$/.test(contentUrl) ? (
        <video autoPlay={false} controls src={contentUrl} alt="creator content" />
    ) : (
        <img src={contentUrl} />
    );

    return (
        <div className="content-preview">
            <div className="content-preview__content">{content}</div>
            {children}
        </div>
    );
}



// WEBPACK FOOTER //
// ./components/content_preview/index.js